import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { AuthorizationService } from "../../../shared/services/authorization.service";
import { SharedDataService } from "../../../shared/sharedData.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { ModalCreateTemplateComponent } from "../create-template/modal-create-template.component";
import { BusinessUnitService } from "../../../shared/services/business-unit.service";

@Component({
    selector: "bu-template-list",
    templateUrl: "./bu-template-list.component.html",
    standalone: false
})
export class BuTemplateListComponent implements OnInit, OnDestroy {
    constructor(
        private _sharedDataService: SharedDataService,
        private route: ActivatedRoute,
        private router: Router,
        private authorizationService: AuthorizationService,
        private _eventBusService: EventBusService,
        private _modalService: BsModalService,
        private businessUnitService: BusinessUnitService,
        private log: NbcLoggerService
    ) {}
    buAccess: any;
    sub = new SubSink();
    selectedBuId: any;
    selectedBuName: any;

    getBuAccess() {
        this.authorizationService.getBUAccess(this.selectedBuId).subscribe({
            next: (result) => {
                this.buAccess = result.reference;
                this._sharedDataService.setBuAccess(this.buAccess);
            },
            error: (err) => this.log.showError(err),
        });
    }
    getParams(route) {
        return {
            ...route.params,
            ...route.children.reduce(
                (acc, child) => ({ ...this.getParams(child), ...acc }),
                {}
            ),
        };
    }

    getBuName() {
        this.businessUnitService.getBuDept(this.selectedBuId).subscribe({
            next: (result) => {
                this.selectedBuName =
                    result.reference[0].businessUnit.displayName;
            },
            error: (err) => this.log.showError(err),
        });
    }

    openCreateTemplateModal() {
        let bsModalRef: BsModalRef;
        const initialState: any = {
            userBuAccess: this.buAccess,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };
        bsModalRef = this._modalService.show(
            ModalCreateTemplateComponent,
            modalOptions
        );
        bsModalRef.content.onSync.subscribe((result) => {
            this._eventBusService.emit(
                new EmitEvent("CreateTemplateModal", "searchTemplates", null)
            );
        });
    }

    ngOnInit() {
        this._sharedDataService.setCss("timesheet");
        const params = this.getParams(this.router.routerState.snapshot.root);
        if (params["buid"]) {
            this.selectedBuId = params["buid"];
            this.getBuAccess();
        }
        this.route.params.subscribe((params) => {
            if (params["buid"]) {
                this.selectedBuId = params["buid"];
                this.getBuAccess();
            }
        });
        this.getBuName();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
